import { stylesheet } from 'typestyle';

const styles = stylesheet({
  buttonsWrapper: {
    width: '100%',
  },
  iOSButtonsWrapper: {
    width: '100%',
    // marginBottom: 100,
  },
  button: {
    marginTop: 24,
  },
});

export default styles;
